export const Svg_093 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={70}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M11.666 61.25v-4.374h35v4.375h-35Zm16.188-15.458L11.666 29.605l5.104-5.25 16.334 16.187-5.25 5.25Zm18.52-18.52L30.188 10.937l5.25-5.104L51.625 22.02l-5.25 5.25Zm14.73 31.062L22.02 19.25l3.063-3.062 39.083 39.083-3.062 3.063Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={23.807}
        x2={50.742}
        y1={14.146}
        y2={55.445}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)